import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { getCurrentCountryContext } from '../../../helpers/countriesHelpers';
import { t } from '../../../i18n';

const holidayPricingApi = new Api('holiday_pricings');
const createHolidayPricingApi = new Api('holiday_pricings/bulk_districts');
const updateHolidayPricingApi = new Api('holiday_pricings/bulk_districts/:id');

function* removeHolidayPricing({ payload }) {
  const { request, id } = payload;

  try {
    const result = yield call(
      sendRequest,
      updateHolidayPricingApi.deleteItem,
      { data: { ...request }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data && result?.status === 200) {
      yield put(actions.removeHolidayPricingSuccess());
      yield put(actions.loadHolidaysRequest());
      yield put(actions.toggleConfirmRemovalModal(false));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.admin.holidayPricing.holiday_pricing_removed_message'),
        }),
      );
    } else {
      yield put(actions.removeHolidayPricingError());
    }
  } catch (error) {
    logger.warn(error);
  }
}

function* updateHolidayPricing({ payload }) {
  const { request, id } = payload;

  try {
    const result = yield call(
      sendRequest,
      updateHolidayPricingApi.updateItem,
      { data: { ...request }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data && result?.status === 200) {
      yield put(actions.updateHolidayPricingSuccess());
      yield put(actions.loadHolidaysRequest());

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.admin.holidayPricing.holiday_pricing_updated_message'),
        }),
      );
    } else {
      yield put(actions.updateHolidayPricingError());
    }
  } catch (error) {
    logger.warn(error);
  }
}

function* createHolidayPricing({ payload }) {
  const { request } = payload;

  try {
    const result = yield call(
      sendRequest,
      createHolidayPricingApi.createItem,
      { data: request },
      notifications.REQUEST_ERROR,
    );

    if (result?.data && result?.status === 200) {
      yield put(actions.createHolidayPricingSuccess());
      yield put(actions.loadHolidaysRequest());

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.admin.holidayPricing.holiday_pricing_added_message'),
        }),
      );
    } else {
      yield put(actions.createHolidayPricingError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadDistricts() {
  try {
    const result = yield call(sendRequest, holidayPricingApi.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { data } = result.data.success;
      data?.districts.unshift({
        id: 'all',
        name: t('dash.admin.holidayPricing.all_districts_label'),
      });

      yield put(actions.loadDistrictsSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadHolidays() {
  const countryCode = getCurrentCountryContext()?.id;

  try {
    const result = yield call(
      sendRequest,
      holidayPricingApi.load,
      { search: { country_id: countryCode } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data?.records) {
      const { records } = result.data.success.data;

      yield put(actions.loadHolidaysSuccess(records));
      yield put(actions.loadDistrictsRequest());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_DISTRICTS_REQUEST, loadDistricts),
    takeEvery(actions.LOAD_HOLIDAYS_REQUEST, loadHolidays),
    takeEvery(actions.CREATE_HOLIDAY_PRICING_REQUEST, createHolidayPricing),
    takeEvery(actions.UPDATE_HOLIDAY_PRICING_REQUEST, updateHolidayPricing),
    takeEvery(actions.REMOVE_HOLIDAY_PRICING_REQUEST, removeHolidayPricing),
  ]);
}
